import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Fieldwork } from 'src/app/modules/pages/fieldwork-report/models/fieldwork';
import { RecordsManager } from 'src/app/modules/records/records-manager';
import { MyUtils } from 'src/app/services/my-utils.service';
import { environment } from "../../../environments/environment";
import { FlagUniqueService } from 'src/app/services/flag-unique.service';


@Component({
  selector: 'app-filter-unique',
  templateUrl: './filter-unique.component.html',
  styleUrls: ['./filter-unique.component.css']
})
export class FilterUniqueComponent implements AfterViewInit {
  keySelected: string = 'uniqueRecords';
  filters: string[] = ['uniqueRecords', 'allRecords'];
  colors: string[] = ['gray', 'gray'];
  radioStyles = this.colors.map(color => ({
    '--mdc-radio-selected-icon-color': color,
    '--mdc-radio-selected-hover-icon-color': color,
    '--mdc-radio-selected-focus-icon-color': color,
    '--mdc-radio-selected-pressed-icon-color': color,
    '--mdc-radio-unselected-icon-color': color,
    '--mdc-radio-unselected-hover-icon-color': color,
    '--mdc-radio-unselected-focus-icon-color': color,
    '--mdc-radio-unselected-pressed-icon-color': color,
    '--mat-radio-label-text-color': color,
    '--mat-radio-ripple-color': color,
    '--mat-radio-checked-ripple-color': color,
  }));

  constructor(
    private recordsManager: RecordsManager<any>,
    public utils: MyUtils,
    private flagUniqueService: FlagUniqueService
  ) { }

  ngAfterViewInit(): void {

    let filterValue = { FlagUnique: 'true' };
    this.recordsManager.applyAsyncFilter(filterValue);
  }

  onChange(newValue: string) {
    this.flagUniqueService.flagUnique = newValue === 'uniqueRecords' ? 'true' : 'false';
    if (!this.recordsManager.isLoading) {
      let filterValue = { FlagUnique: newValue === 'uniqueRecords' ? 'true' : 'false' };
      this.recordsManager.applyAsyncFilter(filterValue);
    }
  }


}
